/**
 * 実行先の呼び名（管理アプリ）
 *
 * タスク詳細の見出しとツール実行カードが同じ言葉・同じ色を使う。
 * 場所ごとに言い換えると、同じ実行先が別のものに見える。
 *
 * **利用者に見える言葉であり、内部の識別子ではない。** 実行基盤の名前
 * （Docker / Fargate 等）は出さない。
 */
import type { SandboxTarget } from '@kyumo/common';

export const SANDBOX_TARGET_LABELS: Record<SandboxTarget, string> = {
  local: 'このパソコン',
  cloud: 'クラウド',
};

export const SANDBOX_TARGET_TITLES: Record<SandboxTarget, string> = {
  local: '利用者のパソコン上の実行環境で実行されました',
  cloud: 'クラウドの実行環境で実行されました',
};

/**
 * クラウド実行時のバッジ配色。
 *
 * カテゴリバッジのラベルはホバーするまで出ないため、一目で分かる手掛かりは
 * 色とアイコンしかない。ローカル（既定色）と必ず違う色にする。
 */
export const CLOUD_SANDBOX_BADGE_COLOR = 'bg-sky-500/20 text-sky-600 dark:text-sky-300';
